/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Deep_P1Inputs */

const en_to_yaml_deep_p1 = /** @type {(inputs: To_Yaml_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The best known YAML hazard is the Norway problem. YAML 1.1 defines a generous set of boolean spellings, including yes, no, on, off, y, and n, so a country code list containing NO can silently become a list containing false. YAML 1.2 narrowed booleans to true and false only, but plenty of readers still implement 1.1 behaviour.`)
};

const ko_to_yaml_deep_p1 = /** @type {(inputs: To_Yaml_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 잘 알려진 YAML 위험은 노르웨이 문제입니다. YAML 1.1은 yes, no, on, off, y, n을 포함해 관대한 불리언 표기 집합을 정의하므로, NO를 담은 국가 코드 목록이 조용히 false를 담은 목록으로 바뀔 수 있습니다. YAML 1.2는 불리언을 true와 false로만 좁혔지만, 여전히 1.1 동작을 구현하는 리더가 많습니다.`)
};

const ja_to_yaml_deep_p1 = /** @type {(inputs: To_Yaml_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も知られた YAML の危険はノルウェー問題です。YAML 1.1 は yes, no, on, off, y, n を含む寛容な真偽値の綴りを定義するため、NO を含む国コードのリストが黙って false を含むリストになりえます。YAML 1.2 は真偽値を true と false だけに狭めましたが、いまも 1.1 の挙動を実装するリーダは数多くあります。`)
};

/**
* | output |
* | --- |
* | "The best known YAML hazard is the Norway problem. YAML 1.1 defines a generous set of boolean spellings, including yes, no, on, off, y, and n, so a country co..." |
*
* @param {To_Yaml_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_deep_p1 = /** @type {((inputs?: To_Yaml_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_deep_p1(inputs)
	if (locale === "ko") return ko_to_yaml_deep_p1(inputs)
	return ja_to_yaml_deep_p1(inputs)
});